import { useMutation, useQueryClient } from "@tanstack/react-query";
import { storiesKeys } from "Api/Queries/Stories/useStoriesQuery";
import { postStoriesPublicIDUnpublish } from "Infrastructure/Api/Api";
import { processResponseWithApiProblemDetails } from "Infrastructure/Api/ApiUtils";

type Props = {
  onSuccess?: () => void;
  onError?: (error: unknown) => void;
};

/** Takes a live story down early; the publication stays as history, so the quota is unchanged. */
export const useUnpublishStoryMutation = ({
  onSuccess,
  onError,
}: Props = {}) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: processResponseWithApiProblemDetails((publicID: string) =>
      postStoriesPublicIDUnpublish(publicID),
    ),
    onSuccess: (_: unknown, publicID: string) => {
      queryClient.invalidateQueries({ queryKey: storiesKeys.lists() });
      queryClient.invalidateQueries({ queryKey: storiesKeys.detail(publicID) });
      onSuccess?.();
    },
    onError,
  });
};
